import { Component, inject, input } from '@angular/core';
import { AdminService } from '../../../../../admin/services/admin.service';
import { InventoryAction } from '../../../../../models/inventory_action.model';
import { InventoryActionService } from '../../../../../services/inventory-action.service';
import { debounceTime } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MoneyPipe } from '../../../../../shared/pipes/money.pipe';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-pricing-edit-form',
  imports: [
    FormsModule,
    MatCheckboxModule,
    MoneyPipe,
    TitleCasePipe,
  ],
  templateUrl: './pricing-edit-form.component.html',
  styleUrl: './pricing-edit-form.component.scss'
})
export class PricingEditFormComponent {

  public inventoryActionForPricing = input.required<InventoryAction>({ alias: 'document' });

  private readonly adminService = inject(AdminService);

  private readonly inventoryActionService = inject(InventoryActionService);


  get isAnswered(): boolean {
    return !this.inventoryActionForPricing().draft;
  }

  get isFinished(): boolean {
    return this.inventoryActionForPricing().finish;
  }

  get isCompleted(): boolean {
    return this.inventoryActionForPricing().completed;
  }

  private get requiredProducts() {
    return this.inventoryActionForPricing().extra_params?.required_products;
  }

  private get selectedProducts() {
    return this.inventoryActionForPricing().extra_params?.selected_products;
  }

  public get Subtotal() {
    return this.selectedProducts?.reduce((acc, product) => acc + product.amount * product.quantity, 0) || 0;
  }

  public get IVA() {
    return this.Subtotal * (this.adminService.getTaxValue() - 1);
  }

  public get Total() {
    return this.Subtotal * this.adminService.getTaxValue();
  }

  

  getRequiredProduct(product_id: number) {
    return this.requiredProducts?.find(product => product.product_id === product_id);
  }

  getSelectedProduct(product_id: number) {
    return this.selectedProducts?.find(product => product.product_id === product_id);
  }

  updateSelectedProductQuantity(pricedProduct, selectedQuantity: number, force = false) {
    if (
      this.isFinished ||
      (!pricedProduct.extra_params.flexible && !force) ||
      selectedQuantity > pricedProduct.quantity
    ) return;

    const selectedProduct = this.getSelectedProduct(pricedProduct.product_id);
    if (selectedQuantity === undefined || selectedQuantity === null || selectedQuantity < 0) {
      selectedProduct.quantity = 1;
    } else {
      selectedProduct.quantity = selectedQuantity;
    }

    this.updateInventoryActionForPricing({ 
      extra_params: {
        ...this.inventoryActionForPricing().extra_params,
        selected_products: this.selectedProducts ,
      }, 
    });
  }

  updateInventoryActionForPricing(changes: Partial<InventoryAction>) {
    if (this.isFinished) return;
 
    this.inventoryActionService
      .update(this.inventoryActionForPricing().id, changes)
      .pipe(
        debounceTime(500),
      )
      .subscribe();
  }

  toggleSelectedProduct(product, checked: boolean) {
    if (checked) {
      this.updateSelectedProductQuantity(product, product.quantity, true); 
    } else {
      this.updateSelectedProductQuantity(product, 0, true); 
    }
  }
}
